import i18n from 'es2015-i18n-tag';
import { Field, Formik, FormikHelpers } from 'formik';
import Input from '../../../../common/ui-components/input/input.component';
import { SportTeamCreateModel } from '../../models/sport-team-create-model';
import { getSportTemplates } from '../../team-service';
import CreateTeam, { CreateTeamFormValue, formSchema } from './create-team.component';
import { useNavigate } from 'react-router';

export interface CreateSportTeamProps {
    createTeam: (model: SportTeamCreateModel) => Promise<void>;
}

const CreateSportTeam = (props: CreateSportTeamProps) => {
    const navigate = useNavigate();

    const onCreate = (
        formValue: CreateTeamFormValue,
        actions: FormikHelpers<CreateTeamFormValue>
    ) => {
        const { name, sport, league, survey } = formValue;
        props
            .createTeam({
                name,
                league,
                sport,
                templateKey: survey.templateKey,
                hasSixPossibleAnswers: survey.hasSixPossibleAnswers,
                isPrinorQuest: survey.isPrinorQuest
            })
            .then(() => {
                navigate(-1);
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    };

    return (
        <Formik
            initialValues={{
                name: '',
                sport: '',
                league: '',
                survey: null
            }}
            validationSchema={formSchema}
            onSubmit={onCreate}
        >
            {formikProps => (
                <CreateTeam {...formikProps} fetchTemplates={getSportTemplates}>
                    <Field
                        component={Input}
                        title={i18n`Sportart`}
                        name="sport"
                        className="create-team__form-field"
                        required
                    />
                    <Field
                        component={Input}
                        title={i18n`Ligazugehörigkeit`}
                        name="league"
                        className="create-team__form-field"
                        required
                    />
                </CreateTeam>
            )}
        </Formik>
    );
};

export default CreateSportTeam;
